var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5C6 4.91 8.91 2 12.5 2C16.09 2 19 4.91 19 8.5C19 14.5 13 14.5 13 18.5C13 20.43 11.43 22 9.5 22C7.57 22 6 20.43 6 18.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.5C15 7.12 13.88 6 12.5 6C11.12 6 10 7.12 10 8.5V9.5C11.1 9.5 12 10.4 12 11.5C12 12.6 11.1 13.5 10 13.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEar);
export default __webpack_public_path__ + "static/media/ear.efa32ead4bf7345b2ac249425724d6d1.svg";
export { ForwardRef as ReactComponent };